import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

import './App.css';
import Home from './pages/home';
import SignUp from './pages/signup';
import Login from './pages/login';
import About from './pages/about';
import Scholarships from './pages/scholarships';
import Navbar from './components/navbar';
import Profile from './pages/profile';
import Contact from './pages/contact';
import ContactConfirmation from './pages/contactConfirmation';
import ApplicationConfirmation from './pages/applicationConfirmation';
import Donate from './pages/donate';
import Applications from './pages/applications';
import Blog from './pages/blog';
import DonationTracking from './pages/donationTracking';
import FaamsScholarship from './pages/faams_scholarship';
import Advisory from './pages/advisory';
import Fundraising from './pages/fundraising';
import Fund from './pages/fund';
import FaamsApplication from './pages/faams-application';
// import Recommender from './pages/recommender'

function App() {
  const navigate = useNavigate();
  const location = useLocation();

  const [user, setUser] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error("Invalid token:", error);
        localStorage.removeItem("token");
        localStorage.removeItem("refresh_token");
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/');
  };

  const hideNavbarRoutes = ['/fundraising', '/fund'];

  return (
    <>
      {!hideNavbarRoutes.includes(location.pathname) && (
        <Navbar user={user} onLogout={handleLogout} />
      )}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/login" element={<Login setUser={setUser} />} />
        <Route path="/about" element={<About />} />
        <Route path="/scholarships" element={<Scholarships />} />
        <Route path="/donate" element={<Donate />} />
        <Route path="/contact" element={<Contact user={user} />} />
        <Route path="/blog" element={<Blog user={user} />} />
        <Route path="/applications" element={<Applications user={user} />} />
        <Route path="/contact-confirmation" element={<ContactConfirmation />} />
        <Route path="/application-confirmation" element={<ApplicationConfirmation />} />
        {/*<Route path="/donation-tracking" element={<DonationTracking />} /> */}
        <Route path="/faams-scholarship" element={<FaamsScholarship user={user}
    setUser={setUser}/>} />
        <Route path="/advisory-board" element={<Advisory />} />
        <Route path="/fundraising" element={<Fundraising />} />
        <Route path="/faams-application/:application_id/:step" element={<FaamsApplication user={user}
    setUser={setUser}/>} />
        {/* <Route path="/recommendation/:token_id" element={<Recommender />}/> */}
        {/* <Route path="/fund" element={<Fund />} /> */}
        <Route
          path="/profile"
          element={user ? <Profile user={user} setUser={setUser} /> : <Navigate to="/login" />}
        />
      </Routes>
    </>
  );
}

export default App;
